<template>
  <div v-title data-title="活动助力">
    <section class="active2-bg">
      <p class="act2-tips">您正在帮助{{formset.WechatName}}完成感恩节回馈活动</p>
      <div class="act2-form">
        <p class="title">帮TA得好礼</p>
        <div class="input-inline bg-white">
          <input type="text" v-model="PicCodeValue" placeholder="请输入图形验证码" />
          <div class="yzmm-img">
            <img :src="'data:image/png;base64,'+VerificationCodePic.Base64" @click="getpiccode()" />
          </div>
        </div>
        <div class="input-inline">
          <input type="text" v-model="user.UserName" placeholder="请输入手机号码" />
          <a href="javascript:void(0)" class="yzmm" @click="getcode()" v-if="getcodeshow">获取验证码</a>
          <a href="javascript:void(0)" class="yzmm" v-if="!getcodeshow">{{waitminutes}}秒</a>
        </div>
        <div class="input-block">
          <input type="text" v-model="user.Password" placeholder="请输入验证码" />
        </div>
        <a href="javascript:void(0)" class="submit" @click="checkcode()">
          <img src="../../assets/img/anniu.png" />
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";

export default {
  name: "fissionactivity",
  data: function() {
    return {
      formset: {},
      disid: "",
      user: { UserName: "", Password: "" },
      getcodeshow: true,
      waitminutes: "",
      codetimer: null,
      VerificationCodePic: { OnceString: "" }, //图形验证码信息
      PicCodeValue: "", //图形验证码值
      activeGuid: "",
      activity: {}
    };
  },
  created: function() {
    var url = window.location.href;
    var disid = this.GetRequest(url)["disid"];
    if (disid != undefined) {
      this.disid = disid;
    }
    var activeGuid = this.GetRequest(url)["activityGuid"];
    if (activeGuid != undefined) {
      this.activeGuid = activeGuid;
    }
    this.getactivity();
    this.initDisInfo();
  },
  mounted: function() {
    this.getpiccode();
  },
  methods: {
    getactivity: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/tbactivity/get", {
          params: {
            activityGuid: this.activeGuid,
            disid: this.disid
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.activity = rep.Data;
              if (this.activity.IsExpired) {
                this.$router.push("/page/activityends");
              }
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    initDisInfo: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getuserbyguid", {
          params: {
            guid: this.disid
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.formset = rep.Data;
              if (this.formset.LoginUserType == 4) {
                Dialog.alert({
                  title: "提示信息",
                  message:
                    "您已经是家游客，无法助力！<br />进入【壹选生活】公众号，回复“参与感恩节活动”，即可参与活动！ "
                }).then(() => {
                  this.$router.push("/app/home");
                });
              }
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    regThirdDistributor: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/regthirddistributor", {
          params: {
            disid: this.disid,
            telephone: this.user.UserName,
            loginType: 4,
            code: this.user.Password,
            activityGuid: this.activeGuid
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              if (
                rep.Data.Token != undefined &&
                rep.Data.Token != null &&
                rep.Data.Token.length > 0
              ) {
                localStorage.setItem("token", JSON.stringify(rep.Data.Token));
                Toast.success("助力成功");
                this.$store.commit("hideFun");
                localStorage.setItem("showFun", false);
                this.$router.push({
                  path: "/page/fissionactivitysuccess", //跳转助力成功页面
                  query: {
                    wechatheadimg: rep.Data.WeChatLogoUrl,
                    parentwechatname: rep.Data.ParentWeChatName
                  }
                });
              }
            } else {
              if (
                rep.Message == "已是家游客，无需注册" ||
                rep.Message == "注册失败，该微信已经绑定家游客"
              ) {
                Dialog.alert({
                  title: "提示信息",
                  message: "您已经是家游客，不能再助力哦"
                }).then(() => {
                  localStorage.removeItem("token");
                  window.location.href = this.GLOBAL.WEB_URL + "/#/app/home";
                });
              } else {
                this.getpiccode();
                Toast.fail(rep.Message);
              }
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    //获取图形验证码
    getpiccode: function() {
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcodepic", {
          params: { codeGuid: this.VerificationCodePic.OnceString }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
              this.VerificationCodePic = rep.Data;
            } else {
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    getcode: function() {
      if (
        this.user.UserName == undefined ||
        this.user.UserName == null ||
        this.user.UserName.length == 0
      ) {
        Toast.fail("手机号不能为空");
        return;
      }
      if (
        this.PicCodeValue == undefined ||
        this.PicCodeValue == null ||
        this.PicCodeValue.length == 0
      ) {
        Toast.fail("图形码不能为空");
        return;
      }
      const TIME_COUNT = 60;
      if (!this.codetimer) {
        this.waitminutes = TIME_COUNT;
        this.getcodeshow = false;
        this.codetimer = setInterval(() => {
          if (this.waitminutes > 0 && this.waitminutes <= TIME_COUNT) {
            this.waitminutes--;
          } else {
            this.getcodeshow = true;
            clearInterval(this.codetimer);
            this.codetimer = null;
          }
        }, 1000);
      }
      this.$http
        .get(this.GLOBAL.BASE_URL + "api/login/getverificationcode", {
          params: {
            picCode: this.PicCodeValue,
            onceString: this.VerificationCodePic.OnceString,
            telephone: this.user.UserName,
            loginType: 4
          }
        })
        .then(
          function(d) {
            var rep = JSON.parse(d.bodyText);
            if (rep.Success) {
            } else {
              this.waitminutes = 0;
              this.getpiccode();
              Toast.fail(rep.Message);
            }
          },
          function(d) {
            console.log(d);
          }
        );
    },
    checkcode: function() {
      if (
        this.user.UserName == undefined ||
        this.user.UserName == null ||
        this.user.UserName.length == 0
      ) {
        Toast.fail("手机号不能为空");
        return;
      }
      if (
        this.PicCodeValue == undefined ||
        this.PicCodeValue == null ||
        this.PicCodeValue.length == 0
      ) {
        Toast.fail("图形码不能为空");
        return;
      }
      if (this.user.Password == "") {
        Toast.fail("验证码不能为空");
        return;
      }

      this.regThirdDistributor();
    }
  }
};
</script>





<style>
/*-----------fxs-----------*/
.fxs-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: url(../../assets/img/fxs-zc.png) no-repeat center top #fdfdfb;
  background-size: 100% 100%;
  z-index: -100;
}

.fxs-card {
  width: 100%;
  margin: 48% auto 0;
  background: url(../../assets/img/fxs-card.png) no-repeat center top;
  background-size: 100% 100%;
  padding: 38% 10px 23% 10px;
  text-align: center;
  box-sizing: border-box;
}

.fxs-card img.profile {
  width: 50px;
  height: 50px;
}

.fxs-card span {
  display: block;
  line-height: 20px;
  font-size: 14px;
}
.fxs-card p {
  width: 55%;
  margin: 10px auto;
  line-height: 30px;
  background: linear-gradient(to right, #f2e5ca, #fcfaf2);
  border-radius: 64px;
}

.fxs-sub {
  display: block;
  width: 60%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  background: linear-gradient(to bottom, #fdb631, #fe7a0d);
  border-radius: 64px;
  margin: 10px auto;
}

.fxs-zc-form {
  width: 60%;
  margin: 10px auto;
}

.fxs-zc-form .fxs-input {
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #d8d9d9;
  padding-bottom: 5px;
  position: relative;
}

.fxs-zc-form .fxs-input input {
  border: none;
  background: inherit;
  text-align: left;
  padding-left: 10px;
  width: 100%;
}

.fxs-zc-form .fxs-input img {
  position: absolute;
  right: 0;
  top: 5px;
  bottom: 5px;
  width: 80px;
  height: 30px;
}

.fxs-zc-form .fxs-input button {
  position: absolute;
  right: 0;
  top: 5px;
  bottom: 5px;
  width: 80px;
  height: 30px;
  background: linear-gradient(to top, #fdb631, #fe7a0d);
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 64px;
}
</style>




// WEBPACK FOOTER //
// src/components/fissionactivity/fissionactivity.vue